import React, { useEffect, useState } from "react";
import config from "../../config";

export default function VersionManager() {
  const [currentVersion, setCurrentVersion] = useState("");
  const [newVersion, setNewVersion] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Cargar versión actual
  useEffect(() => {
    async function loadVersion() {
      try {
        const fileKey = "json/tms_mobile.json";
        console.log(config);

        // Construyes la URL con query param
        const url = `${config.apiGateway.URL}Files?fileKey=${encodeURIComponent(fileKey)}`;

        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": config.UploadFileAccessToken
          }
        });

        if (!res.ok) throw new Error("Error en la petición");

        const data = await res.json();

        console.log("Respuesta: ", data);

        setCurrentVersion(data.version);
        setNewVersion(data.version);
      } catch (err) {
        console.error(err);
        setError("No se pudo cargar la versión actual.");
      } finally {
        setLoading(false);
      }
    }

    loadVersion();
  }, []);
  const validateVersion = (v) => /^[0-9]+(\.[0-9]+)*$/.test(v);

  const updateVersion = async () => {
    if (!validateVersion(newVersion)) {
      alert("Formato de versión inválido. Ej: 1.0.5");
      return;
    }

    if (newVersion === currentVersion) {
      alert("La versión es la misma.");
      return;
    }

    setSaving(true);
    setError("");

    try {
      const fileKey = "json/tms_mobile.json";
      const url = `${config.apiGateway.URL}Files?fileKey=${encodeURIComponent(fileKey)}`;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": config.UploadFileAccessToken
        },
        body: JSON.stringify({
          version: newVersion
        })
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Respuesta servidor:", text);
        throw new Error("Error al actualizar versión");
      }

      setCurrentVersion(newVersion);
      alert("¡Versión actualizada correctamente!");
    } catch (err) {
      console.error(err);
      setError("Error actualizando versión.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 40, fontSize: 18 }}>
        Cargando versión...
      </div>
    );
  }

  return (
    <div
      style={{
        position: "absolute",      // Esto permite posicionarlo respecto a la pantalla
        top: "30%",                // 50% desde arriba
        left: "50%",               // 50% desde la izquierda
        transform: "translate(-50%, -50%)", // Centrado exacto
        maxWidth: 380,
        padding: 20,
        borderRadius: 12,
        background: "#fff",
        boxShadow: "0 4px 18px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ marginBottom: 10, textAlign: "center" }}>Gestión de versión</h2>

      {error && (
        <div
          style={{
            background: "#ffe1e1",
            color: "#b40000",
            padding: 10,
            borderRadius: 6,
            marginBottom: 10,
            fontSize: 14
          }}
        >
          {error}
        </div>
      )}

      <p style={{ fontSize: 16 }}>
        <strong>Versión actual:</strong> {currentVersion}
      </p>

      <label style={{ display: "block", marginTop: 15, marginBottom: 6 }}>
        Nueva versión:
      </label>

      <input
        type="text"
        value={newVersion}
        onChange={(e) => setNewVersion(e.target.value)}
        style={{
          width: "100%",
          padding: "10px 12px",
          fontSize: 15,
          borderRadius: 8,
          border: "1px solid #ccc",
          marginBottom: 15
        }}
      />

      <button
        onClick={updateVersion}
        disabled={saving}
        style={{
          width: "100%",
          padding: "12px 15px",
          fontSize: 16,
          background: saving ? "#999" : "#4A90E2",
          color: "white",
          border: "none",
          borderRadius: 8,
          cursor: saving ? "not-allowed" : "pointer",
          boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
          transition: "0.2s"
        }}
      >
        {saving ? "Guardando..." : "Actualizar versión"}
      </button>
    </div>
  );
}
